import { get, post, put, del } from '@api/request';

export async function fetchPreference(
  { userService },
  authenticationToken,
  { userId },
) {
  const url = `${userService}/trueprodigy/user/${userId}/preference/appraisal`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function persistPreference(
  { userService },
  authenticationToken,
  { userId, data },
) {
  const url = `${userService}/trueprodigy/user/${userId}/preference/appraisal`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function fetchWaitingRoomConfigOptions(
  { userService },
  authenticationToken,
) {
  const url = `${userService}/conference/waitingroomconfigurationoptions`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchWaitingRoomConfig(
  { userService },
  authenticationToken,
  { activeOnly },
) {
  const url = `${userService}/conference/waitingroomconfigurations?activeOnly=${activeOnly}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAllWaitingRoomConfig(
  { userService },
  authenticationToken,
) {
  const url = `${userService}/conference/waitingroomconfigurations`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createWaitingRoomConfig(
  { userService },
  authenticationToken,
  { payload },
) {
  const url = `${userService}/conference/waitingroomconfigurations`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateWaitingRoomConfig(
  { userService },
  authenticationToken,
  { roomID, payload },
) {
  const url = `${userService}/conference/waitingroomconfiguration/${roomID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteWaitingRoomConfig(
  { userService },
  authenticationToken,
  { roomID },
) {
  const url = `${userService}/conference/waitingroomconfiguration/${roomID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchWaitingRoomRecords(
  { userService },
  authenticationToken,
  { roomID },
) {
  const url = `${userService}/conference/waitingroom/${roomID}/records`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSortWaitingRoomRecords(
  { userService },
  authenticationToken,
  { roomID },
) {
  const url = `${userService}/conference/waitingroom/${roomID}/sort`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function fetchWaitingRoomAllRecords(
  { userService },
  authenticationToken,
) {
  const url = `${userService}/conference/waitingroom/allrecords`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchWaitingRoomAllRecordsByType(
  { userService },
  authenticationToken,
  { roomType },
) {
  const url = `${userService}/conference/waitingroom/allrecords?roomType=${roomType}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function moveWaitingRoomRecord(
  { userService },
  authenticationToken,
  { roomID, waitingRoomCheckInID, payload },
) {
  const url = `${userService}/conference/waitingroom/${roomID}/move/${waitingRoomCheckInID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchSimilarRooms(
  { userService },
  authenticationToken,
  { roomID },
) {
  const url = `${userService}/conference/waitingroomconfiguration/${roomID}/similarrooms`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function moveToDifferentRoom(
  { userService },
  authenticationToken,
  { payload },
) {
  const url = `${userService}/conference/waitingroom/movedifferentroom`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function createCheckIn(
  { userService },
  authenticationToken,
  { roomID, payload },
) {
  const url = `${userService}/conference/waitingroom/${roomID}/checkin`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchCheckInProperties(
  { userService },
  authenticationToken,
  { checkInID },
) {
  const url = `${userService}/conference/waitingroom/checkin/${checkInID}/properties`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertCheckInProperty(
  { userService },
  authenticationToken,
  { checkInID, payload },
) {
  const url = `${userService}/conference/waitingroom/checkin/${checkInID}/properties`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function insertCheckInPropertyList(
  { userService },
  authenticationToken,
  { checkInID, payload },
) {
  const url = `${userService}/conference/waitingroomcheckin/${checkInID}/propertylist`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteCheckInProperty(
  { userService },
  authenticationToken,
  { checkInPID },
) {
  const url = `${userService}/conference/waitingroom/checkinproperty/${checkInPID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function unfinalizedProperty(
  { conferenceService },
  authenticationToken,
  { checkInID },
) {
  const url = `${conferenceService}/conference/waitingroom/checkin/${checkInID}/unfinalizedproperty`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function finalizeCheckInProperty(
  { userService },
  authenticationToken,
  { checkInPID, payload },
) {
  const url = `${userService}/conference/waitingroom/checkinproperty/${checkInPID}/setfinalize`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function setCheckInActiveProperty(
  { userService },
  authenticationToken,
  { checkInPID },
) {
  const url = `${userService}/conference/waitingroom/checkinproperty/${checkInPID}/setactive`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function validCheckInProperty(
  { userService },
  authenticationToken,
  { roomID, payload },
) {
  const url = `${userService}/conference/waitingroom/${roomID}/isvalid?multiYear=1`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function validCheckInPropertyID(
  { userService },
  authenticationToken,
  { pID },
) {
  const url = `${userService}/conference/waitingroomcheckin/property/${pID}/isvalid?multiYear=1`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function validateCheckIn(
  { userService },
  authenticationToken,
  { roomID, payload },
) {
  const url = `${userService}/conference/waitingroom/${roomID}/validatecheckin`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchCheckInRecord(
  { userService },
  authenticationToken,
  { checkInID },
) {
  const url = `${userService}/conference/waitingroom/checkin/${checkInID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateCheckInRecord(
  { userService },
  authenticationToken,
  { checkInID, payload },
) {
  const url = `${userService}/conference/waitingroom/checkin/${checkInID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchMessageHistory(
  { userService },
  authenticationToken,
  { checkInID },
) {
  const url = `${userService}/conference/waitingroom/checkin/${checkInID}/messagehistory`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchRevisionHistory(
  { userService },
  authenticationToken,
  { checkInID },
) {
  const url = `${userService}/conference/waitingroom/checkin/${checkInID}/revisionhistory`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function directAssignmentFromWaitingRoom(
  { userService },
  authenticationToken,
  { panelID, payload },
) {
  const url = `${userService}/prodigyappeals/appealpanel/${panelID}/directassignmentsfromwaitingroom`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function finalizeWaitingRoomRecord(
  { userService },
  authenticationToken,
  { roomID, payload },
) {
  const url = `${userService}/conference/waitingroom/${roomID}/removefinalizecheckin`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function setPositionalExclusion(
  { userService },
  authenticationToken,
  { roomID, payload },
) {
  const url = `${userService}/conference/waitingroom/${roomID}/setpositionalexclusion`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function clearPositionalExclusion(
  { userService },
  authenticationToken,
  { roomID, payload },
) {
  const url = `${userService}/conference/waitingroom/${roomID}/clearpositionalexclusion`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchCheckInPropertyAppeal(
  { userService },
  authenticationToken,
  { checkInPID },
) {
  const url = `${userService}/conference/waitingroom/checkinproperty/${checkInPID}/appeal`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchCheckInPropertyAppealInformal(
  { userService },
  authenticationToken,
  { checkInPID },
) {
  const url = `${userService}/conference/waitingroom/checkinproperty/${checkInPID}/appeal/informal`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateCheckInPropertyAppeal(
  { userService },
  authenticationToken,
  { checkInPID, payload },
) {
  const url = `${userService}/conference/waitingroom/checkinproperty/${checkInPID}/appeal`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function updateCheckInPropertyAppealInformal(
  { userService },
  authenticationToken,
  { checkInPID, payload },
) {
  const url = `${userService}/conference/waitingroom/checkinproperty/${checkInPID}/appeal/informal`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function movePropertyNewCheckIn(
  { conferenceService },
  authenticationToken,
  { checkInID, payload },
) {
  const url = `${conferenceService}/conference/waitingroom/checkin/${checkInID}/createnew`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function movePropertyToExistingCheckIn(
  { conferenceService },
  authenticationToken,
  { checkInID, payload },
) {
  const url = `${conferenceService}/conference/waitingroom/checkin/${checkInID}/moveexistingcheckin`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function reopenCheckIn(
  { userService },
  authenticationToken,
  { checkInID },
) {
  const url = `${userService}/conference/waitingroom/checkin/${checkInID}/reopen`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function moveCheckInToDifferentRoom(
  { conferenceService },
  authenticationToken,
  { checkInID, payload },
) {
  const url = `${conferenceService}/conference/waitingroom/checkin/${checkInID}/movetodifferentroom`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}
